export default "__VITE_ASSET__D1PQA$Rr__"